import * as React from 'react'

function SvgCamera(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 24V11h-4a1.5 1.5 0 01-1.2-.6L17.25 7h-4.5l-2.55 3.4A1.5 1.5 0 019 11H5v13h20zm1.5 3h-23A1.5 1.5 0 012 25.5v-16A1.5 1.5 0 013.5 8h4.75l2.55-3.4A1.5 1.5 0 0112 4h6a1.5 1.5 0 011.2.6L21.75 8h4.75A1.5 1.5 0 0128 9.5v16a1.5 1.5 0 01-1.5 1.5zM15 19a2 2 0 100-4 2 2 0 000 4zm4.584-4H20a1.5 1.5 0 000-3h-5a5 5 0 104.584 3z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgCamera
